<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="this.company_name +' '+ $t('invoices')"
          :directory="$t('datatables')"
          :icon="'grid'"/>
          <app-breadcrumb
          :page-title="this.titleinvoice"
          :directory="$t('datatables')"
          :icon="'grid'"/>
      </div>
    </div>
    <app-table
      :id="tableId"
      :options="options"
      @action="getListAction"
    />
  </div>
</template>

<script>
// import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../Demo/Tables/mixins/TableHelpers";
import { axiosGet } from '../../../../../Helpers/AxiosHelper';

export default {
  // extends: CoreLibrary,
  name: "tab-filter",
  mixins: [TableHelpers],
  props: {
    id: Number,
  },
  data() {
    return {
      invoice: {},
      isAddEditModalActive: false,
      isEditModalActive:false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      titleinvoice: "",
      company_name: "",
      tableId: "filter-without-wrapper",
      filteredData: {
        status: "",
      },
      search: "",
      rowData: {},
      options: {
        name: this.$t("tab_filter"),
        url: actions.CUSTOMER_INVOICE_LIST,
        datatableWrapper: false,
        tableShadow: false,
        showHeader: true,
         columns: [
          {
            title: this.$t("invoice_#"),
            type: "custom-html",
            key: "invoice_number",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          // {
          //   title: this.$t("customers"),
          //   type: "custom-html",
          //   key: "company_name",
          //   modifier: (value) => {
          //     let company_name = value ;
          //     this.titleinvoice = company_name;
          //     return `<span>${this.$t(value.company_name)}</span>`;
          //   },
          // },
          // {
          //   title: this.$t("customer"),
          //   type: "custom-html",
          //   key: "customer",
          //   modifier: (value) => {
          //     return `<span>${this.$t(value.full_name)}</span>`;
          //   },
          // },
          {
            title: this.$t("invoice_date"),
            type: "custom-html",
            key: "invoice_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("due_date"),
            type: "custom-html",
            key: "due_date",
            modifier: (value) => {
              var result = '';
              let ClassName = "warning";

              if (value == null) {
                result = "None";
                ClassName = 'danger';
              }
              else {
                const moment = require('moment');
                // Define your due date and current date
                const dueDate = moment(value+' 23:59:59'); // Replace with your due date
                const currentDate = moment(); // Current date and time

                // Calculate the difference in time
                const timeDiff = dueDate.diff(currentDate);
                if (timeDiff > 0) {
                  const duration = moment.duration(timeDiff);
                  if (duration.days() > 0) {
                    result = `${duration.days()} day${duration.days() > 1 ? 's' : ''} left`;
                    if(duration.days() > 30) {
                      ClassName = 'success';
                    }
                  } else if (duration.hours() > 0) {
                    result = `${duration.hours()} hour${duration.hours() > 1 ? 's' : ''} left`;
                  } else {
                    result = `${duration.minutes()} minute${duration.minutes() > 1 ? 's' : ''} left`;
                  }
                } else {
                    result = 'The due date has passed.';
                    ClassName = 'danger';
                }
              }
              // return `<span>${this.$t(result)}</span>`;
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                  result
              )}</span>`;
            },
          },
          {
            title: this.$t("total"),
            type: "custom-html",
            key: "amount",
            modifier: (value) => {
              return `<span>${this.$t(value.toString())}</span>`;
            },
          },
          {
            title: this.$t("paid_due"),
            type: "custom-html",
            key: "amount_due",
            modifier: (value) => {
              return `<span>${this.$t(value.toString())}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "danger";
              let val = "";

              if (value === "succeeded") {
                ClassName = `success`;
                val = "Paid";
              } else if (value === "pending") {
                ClassName = `warning`;
                val = "Overdue";
              }

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                val
              )}</span>`;
            },
          },
        ],
        actions: [
        //   {
        //     title: this.$t("edit"),
        //     icon: "edit",
        //     type: "none",
        //   },
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
          // {
          //     title: this.$t('download'),
          //     icon: 'download',
          //     type: 'none',
          // }
        ],
        showFilter: false,
        // showSearch: true,
        showCount: true,
        // showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
      userFilterOptions: [
        { id: "", value: "All Invoices" },
        { id: "succeeded", value: "Paid" },
        { id: "pending", value: "Un Paid" },
        // { id: "invited", value: "Invited" },
      ],
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    // getSearchValue(value) {
    //   let instance = this;
    //   this.search = value;
    //   setTimeout(function () {
    //     instance.$hub.$emit("reload-" + instance.tableId);
    //   });
    // },
    // getFilterValue(item) {
    //   this.filteredData.status = item;
    //   
    //   this.$hub.$emit("reload-" + this.tableId);
    // },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.getFilterValue();
      this.reSetData();
    },
    closeEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isEditModalActive = false;
      this.getFilterValue();
      this.reSetData();
    },
    getListAction(rowData, actionObj, active) {
            this.rowData = rowData;

            if (actionObj.title == this.$t('view')) {
                // window.location = '/buyer/customer/invoice/view/'+ rowData.id;
                this.$emit("invoiceId", rowData.id);
            }
            // else if (actionObj.title == this.$t('edit'))
            // {
            //   if (rowData.status == 'succeeded')
            //   {
            //     this.$toastr.s('You are already paid customer');
            //   }
            //   else
            //   {
            //     this.selectedUrl = `${actions.SINGLE_INVOICE_SHOW}/${rowData.id}`;
            //     this.isEditModalActive = true;
            //   }
              
            // }
        },
    getCustomerName() {
      // alert('d');
      // let myLocation = location.href;
      // let split = myLocation.split('/');
      
      // let id = split[7].split('?')[0];
      
     
      axiosGet(actions.CUSTOMER_NAME+'/'+ this.id)
      .then((response) => {
        //  alert(actions.CUSTOMER_NAME+'/'+id);
          
        this.company_name = response.data ? response.data.company_name : '---';
        // this.titleinvoice = '('+ response.data.full_name+')';
        })
        .catch((error) => {
          
        });
    },
    getInvoice() {
        // let myLocation = location.href;
        // let split = myLocation.split("/");
        // let split_ = split[7].split("?");
        
        // let a = this.options.url.append(this.id);
        
        // this.options.url = this.options.url + '/' + split_[0];
        this.options.url = this.options.url + '/' + this.id;
    }
    
  },
  mounted() {

    // this.getInvoiceDownload();
    this.getInvoice();
    this.getCustomerName();
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
